var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "",
        visible: _vm.isOpen,
        width: "8.48rem",
        "append-to-body": "",
        "close-on-click-modal": false,
        "destroy-on-close": "",
        footer: null,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
        close: _vm.close,
      },
    },
    [
      _c("div", { staticStyle: { width: "90%", margin: "0 auto" } }, [
        _c("div", { staticClass: "img-box" }, [
          _c("img", {
            attrs: { src: require("@/assets/image/loan/success.png") },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "img-title" }, [
          _vm._v(
            _vm._s(
              _vm.pageData.isAll
                ? "Borrow Position Closed!"
                : "Partial Repayment Confirmed!"
            )
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "spaceCenter" }, [
          _c(
            "div",
            {
              staticClass: "detail-item spaceLeft",
              staticStyle: { margin: "0.2rem 0.4rem" },
            },
            [
              _c("span", { staticClass: "detail-item-label" }, [
                _vm._v("Collateral Released:"),
              ]),
              _vm._v(" "),
              _c(
                "span",
                [
                  _c("big-number", {
                    attrs: { number: _vm.pageData.unitRefund },
                  }),
                ],
                1
              ),
              _c("span", { staticClass: "unit" }, [_vm._v("UNIT")]),
            ]
          ),
          _vm._v(" "),
          !_vm.pageData.isAll
            ? _c(
                "div",
                {
                  staticClass: "detail-item spaceLeft",
                  staticStyle: { margin: "0.2rem 0.4rem" },
                },
                [
                  _c("span", { staticClass: "detail-item-label" }, [
                    _vm._v("Pending Repayment:"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    [
                      _c("big-number", {
                        attrs: { number: _vm.pageData.Unrepaid },
                      }),
                    ],
                    1
                  ),
                  _c("span", { staticClass: "unit" }, [_vm._v("TCash")]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }